import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { lookupProjectAndLicenses } from '../../../redux/globalLicenseCorrections/actions';
import { selectors } from '../../../redux/globalLicenseCorrections/slice';
import { onEnter } from '../../../utils';
import { BUTTON_SIZE, BUTTON_TYPE, LoaderButton } from '../../generic/Button';
import LabeledTextInput from '../../generic/Forms/LabeledTextInput';

import css from './ProjectSelector.module.less';

/**
 * A form that allows the user to choose a project.
 *
 * Currently only supports exact locators.
 */
export const ProjectSelector: React.VFC = () => {
  const dispatch = useDispatch();
  const projectValue = useSelector(selectors.projectSelector);
  const [projectQuery, setProjectQuery] = React.useState('');

  const onProjectLookup = React.useCallback(() => {
    dispatch(lookupProjectAndLicenses(projectQuery.trim()));
  }, [dispatch, projectQuery]);

  return (
    <div>
      <div className={css.projectSelectorForm}>
        <LabeledTextInput
          labelVariant="legacy"
          label="Component Locator"
          value={projectQuery}
          onChange={setProjectQuery}
          onKeyDown={onEnter(onProjectLookup)}
          isDisabled={projectValue.isLoading}
        />
        <div className={css.projectSelectorButton}>
          <LoaderButton
            type={BUTTON_TYPE.PRIMARY}
            size={BUTTON_SIZE.LARGE}
            onClick={onProjectLookup}
            isDisabled={projectValue.isLoading || !projectQuery}
            isLoading={projectValue.isLoading}>
            Go
          </LoaderButton>
        </div>
      </div>
    </div>
  );
};
